import { render, staticRenderFns } from "./barra-principal.vue?vue&type=template&id=7ec347b4&scoped=true&"
import script from "./barra-principal.vue?vue&type=script&lang=ts&"
export * from "./barra-principal.vue?vue&type=script&lang=ts&"
import style0 from "./barra-principal.vue?vue&type=style&index=0&id=7ec347b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec347b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow,VSpacer})
